<template>
  <div class="breadcrumb-section" style="margin-top: 70px;">
    <div class="container p-0">
      <div class="page-title">
        <router-link :to="{ path: '/shop' }" class="previous-page">
          <font-awesome-icon icon="fa-solid fa-angle-left" />
        </router-link>
        <h3 class="text-capitalize"> <span>{{ title }}</span> <span>{{value}}</span></h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['title', 'value']
}
</script>